import { connect } from 'react-redux';
import { getProject } from 'project/ducks/project';
import RevisionDisclosures from 'entries/components/revision_disclosures';

export const mapStateToProps = (state) => {
  const project = getProject(state);

  return {
    project
  };
};

export default connect(mapStateToProps)(RevisionDisclosures);



// WEBPACK FOOTER //
// ./entries/containers/revision_disclosures.js